import { connect } from 'react-redux'
import InfoUI from './InfoUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../../../../ApplicationState';
import ServiceInfoState from '../../State/ServiceInfoState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import { actionAddOrder, actionFetchServiceInfo } from '../../Actions/ActionCreator';
import InfoDispatch from './model';




const mapStateToProps = (state: ApplicationState): IState<ServiceInfoState> => {
    return {
        state: state.info
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<InfoDispatch> => ({
    dispatcher: {
        fetch: (serviceId : number) => { dispatch(actionFetchServiceInfo(serviceId) as any) },
        order: (infoId : number) => { dispatch(actionAddOrder(infoId) as any) }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(InfoUI)